import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
// import store from '@/page/store';
import { generateRoutes } from '@/utils/env'
import { getAllowedUrls, isPathAllowed } from '@/utils/menuPermission'
import { getRoletype } from '@/utils/getUser'

Vue.use(Router);

// 不需要权限拦截的路由前缀
const WHITE_LIST = ['/login', '/home', '/order-query']

/**
 * 等待 roleType 写入 localStorage，最多等待 3 秒
 * 登录后 getAccountRoleType 是异步的，ACCOUNT_DTO 里的 roleType 可能还未就绪
 */
function waitForRoleType(timeout = 3000, interval = 50) {
  return new Promise((resolve) => {
    const start = Date.now()
    const check = () => {
      const roleType = getRoletype()
      if (roleType) {
        resolve(roleType)
      } else if (Date.now() - start >= timeout) {
        resolve(null) // 超时，放行
      } else {
        setTimeout(check, interval)
      }
    }
    check()
  })
}

export default ctx => {
  const router = new Router({
    linkExactActiveClass: 'active',
    mode: 'history',
    routes: generateRoutes(ctx)
  });
  // 注册全局路由守卫进行路由鉴权
  router.beforeEach(async (to, from, next) => {
    const path = to.path
    const type = localStorage.getItem('LOGIN_TYPE')

    if (path === '/') {
      return next('/home');
    }

    // 查单页面无需登录，直接放行
    if (path.startsWith('/order-query')) {
      return next();
    }

    // 如果非登录页面
    if (!(path.indexOf('/login') >= 0)) {
      const token = localStorage.getItem('TOKEN');
      // 检测localStorage是否存在token
      if (!token) {
        Message.error('请先登录');
        localStorage.setItem('TOKEN', '')
        localStorage.setItem('ACCOUNT_DTO', '')
        localStorage.setItem('ACCOUNT_INFO', '')
        return next('/login');
      }

      // 白名单页面不做菜单权限拦截
      const inWhiteList = WHITE_LIST.some(p => path.startsWith(p))
      if (!inWhiteList) {
        // roleType 可能还未写入（登录后异步获取），等待就绪
        const roleType = getRoletype() || await waitForRoleType()
        if (roleType) {
          const allowedUrls = getAllowedUrls()
          const allowed = isPathAllowed(path, allowedUrls)
          console.log('[路由权限]', {
            path,
            roleType,
            allowedUrls,
            allowed
          })
          if (!allowed) {
            // 无权限一律跳 /home:含「0 权限角色」(allowedUrls 为空,isPathAllowed 必为 false)
            console.log('[路由拦截] 无权限访问', path, '→ 跳转到 /home', { allowedUrls })
            Message.warning('您没有权限访问该页面')
            return next('/home')
          }
        }
      }
    }
    next();
  });

  return router;
};

